<template>
  <div>
    <h3 class="address mb-3">
      {{titleLead}}
      <small class="address__tail text-muted">{{titleTail}}</small>
    </h3>
    <div class="row">
      <div class="col-lg-3">
        <div v-for="category in categorisedFeatures" :key="category.name">
          <h6 v-if="category.features.length > 0">
            {{$t(`LayerCategories.${category.name}`)}}
          </h6>
          <ul class="feature-list list-unstyled"  v-if="category.features.length > 0">
            <FeatureItem v-for="feature in category.features"
              v-bind:key="feature.id"
              v-bind:feature="feature"
              v-bind:selected="feature == selectedFeature"
              v-on:select-feature="selectedFeature = feature" />
          </ul>
        </div>
      </div>
      <div class="col">
        <Feature v-if="selectedFeature" :uuid="selectedFeature.id" :embedded="true" />
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import Geohash from "latlon-geohash";
import Address from "@/models/address";
import Feature from "@/views/Feature";
import FeatureItem from "@/components/Address/FeatureItem";

const LAYER_CATEGORIES = [{
  name: "statistical_areas",
  layerIdentifiers: ["SA12018", "SA22018"],
}, {
  name: "administrative_areas",
  layerIdentifiers: ["TA2018", "REGC2018"]
}];

export default {
  props: ["geohash", "slug"],
  components: { Feature, FeatureItem },
  apollo: {
    features: {
      query: gql `query fetchFeaturesByPoint($point:geometry) {
        features(where: {geom: {_st_contains: $point}}, order_by: {layer: {sort_order: asc}}) {
          id
          name
          source_identifier
          layer{
            id
            name
            source_identifier
          }
        }
      }`,
      variables() {
        return {
          point: {
            type: "Point",
            coordinates: [this.coords.lon, this.coords.lat]
          }
        }
      }
    }
  },
  mounted() {
    this.$store.dispatch("showAddress", this.address);
  },
  destroyed() {
    this.$store.dispatch("clearMarkers");
  },
  data() {
    return {
      features: [],
      selectedFeature: null
    };
  },
  computed: {
    categorisedFeatures() {
      return LAYER_CATEGORIES.map((c) => {
        let filteredFeatures = this.features.filter((f) => {
          return c.layerIdentifiers.indexOf(f.layer.source_identifier) >= 0
        })
        return { name: c.name, features: filteredFeatures }
      })
    },
    address() {
      return new Address(this.title, this.coords.lat, this.coords.lon);
    },
    coords() {
      return Geohash.decode(this.geohash);
    },
    title() {
      return this.slug.replace(/-/g, " ");
    },
    titleLead() {
      return this.title.match(/^([\w\s]*,)(.*)$/)[1];
    },
    titleTail() {
      return this.title.match(/^([\w\s]*,)(.*)$/)[2];
    }
  },
  watch: {
    features(newFeatures) {
      this.selectedFeature = newFeatures[0];
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/mixins";

.address__tail {
  @include media-breakpoint-down(md) {
    display: none;
  }
}

.feature-list {
  @include media-breakpoint-down(lg) {
    white-space: nowrap;
    overflow: scroll;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Address.vue